export default "__VITE_ASSET__Cp82By4N__"